import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Checkbox from 'components/connectedForm/CheckboxInput';
import styles from 'styles/partials/_selectable-list-option.css';

export default class SelectableListCheckboxOption extends Component {
  render() {
    const highlightClass = this.props.highlight ? styles['optionHighlight'] : styles['option'];
    const disabledClass = this.props.option.readOnly ? styles['disabled'] : '';
    return (
      <div
        className={`${highlightClass} ${disabledClass}`}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <Checkbox
          id={`${this.props.dataid}_${this.props.option.id}`}
          outerClass="listCheckboxInputGroup"
          label={this.props.option[this.props.descriptionField]}
          value={this.props.option.selected}
          readOnly={this.props.option.readOnly}
          onChange={e => {
            this.props.selectOption();
          }}
        />
      </div>
    );
  }
}

SelectableListCheckboxOption.propTypes = {
  option: PropTypes.object,
  highlight: PropTypes.bool,
};

SelectableListCheckboxOption.defaultProps = {
  descriptionField: 'description',
};
